import { GuidedTour, Orientation } from "ngx-guided-tour";

export const viewPlanningTour: GuidedTour = {
    tourId: 'viewPlanning',
    useOrb: false,
    steps: [
        {
            title: 'Planejamento',
            selector: '.card.g',
            content: 'Prontinho! Este é seu <strong>Ciclo de Estudos</strong>! Para ver o nome de cada disciplina, passe o mouse por aqui.',
            orientation: Orientation.Left,
            highlightPadding: 5,
        },
        {
            title: 'Planejamento',
            selector: '.card.d',
            content: 'Organizamos aqui as <strong>próximas atividades</strong> do seu ciclo! Para iniciar o cronômetro, basta clicar em <i class="fas fa-play-circle">',
            orientation: Orientation.Right,
            highlightPadding: 5,
        },
        {
            title: 'Planejamento',
            selector: '#allPlanningSubjects>div',
            content: 'Conforme for avançando nos estudos, é aqui que iremos informá-lo também das revisões a serem feitas.',
            orientation: Orientation.Right,
            highlightPadding: 10,
        }
    ]
};